import React, { useEffect, useState } from "react";
import LoginChecked from "../Shared/LoginChecked";
import Header from "../Layout/Header";
// import SalesMenu from "./SalesMenu";
import axios from "axios";
import config from "../../config";
import {
  Space,
  Table,
  Popconfirm,
  Pagination,
  Row,
  Col,
  Breadcrumb,
  Button,
  Input,
  DatePicker,
  Form,
  Select,
  message,
  Tooltip,
} from "antd";
import { Link, NavLink } from "react-router-dom";
import {
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  PlusOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import moment from "moment";
import dayjs from "dayjs";
import { NumberFormat } from "../Shared/Utility";

function ViewSales() {
  const [currentPage, setCurrentPage] = useState(1);

  const AccessKey = localStorage.getItem("AccessKey");
  const UserID = localStorage.getItem("ID");
  // SignIn stores User_Type in Member_Type; also prefer User_Type when present
  const userType = (
    localStorage.getItem("User_Type") ||
    localStorage.getItem("Member_Type") ||
    ""
  ).trim();
  const canSeeProfit =
    userType.length > 0 &&
    userType.toLowerCase() !== "operator";

  const [loading, setLoading] = useState(false);

  const [StartDate, SetStartDate] = useState("");
  const [EndDate, SetEndDate] = useState("");

  const [ListofSale, SetListofSale] = useState([]);
  const [ListofSaleWithTotal, SetListofSaleWithTotal] = useState([]);
  const [TotalSales, SetTotalSales] = useState("");
  const [CashTotal, SetCashTotal] = useState(0);
  const [CreditTotal, SetCreditTotal] = useState(0);
  const [TotalProfit, SetTotalProfit] = useState(0);
  const [isDeleted, setIsDeleted] = useState(false);

  // pagination
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [totalRecords, setTotalRecords] = useState(0);

  // Match Sale/GetSales defaults when filters are cleared (print must use the same range).
  const printStartDate = StartDate || "2022-01-01";
  const printEndDate = EndDate || dayjs().add(2, "day").format("YYYY-MM-DD");

  useEffect(() => {
    document.title = "Manage Sales";

    setLoading(true);
    setIsDeleted(false);
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      StartDate: StartDate,
      EndDate: EndDate,
      PageNo: pageNo,
      PageSize: pageSize,
    };


    var api_config = {
      method: "post",
      url: config.base_url + "Sale/GetSales",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

  

    axios(api_config)
      .then(function (response) {
       
        if (response.data.status_code == 1) {


          SetListofSale(response.data.listofSale);
          SetTotalSales(response.data.TotalSales);
          SetCashTotal(response.data.CashTotal);
          SetCreditTotal(response.data.CreditTotal);
          SetTotalProfit(response.data.TotalProfit || 0);
          setTotalRecords(response.data.totalRecords);

          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [StartDate, EndDate, pageNo, pageSize, isDeleted]);

  useEffect(() => {
    const totalsRow = {
      ID: null,
      InvoiceNo: "",
      Dated: "",
      Description: "Total",
      Cash_Total: CashTotal,
      Credit_Total: CreditTotal,
      TotalSales: TotalSales,
      Profit: TotalProfit,
    };

    SetListofSaleWithTotal([...ListofSale, totalsRow]);
  }, [ListofSale, CashTotal, CreditTotal, TotalSales, TotalProfit]);

  const handelDelete = (ID) => {
    setLoading(true);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      ID: ID,
    };
  
    const api_config = {
      method: "post",
      url: config.base_url + "Sale/DeleteSales",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        
        if (response.data.status_code === 1) {
          setIsDeleted(true);
          setLoading(false);
          message.success(response.data.status_message);
        } else {
          setLoading(false);
          message.error(response.data.status_message);
        }
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  };

  const columns = [
    {
      title: "Sr.#",
      dataIndex: "sr",
      key: "sr",
      render: (_, record, index) =>
        record.ID ? index + 1 + pageSize * (pageNo - 1) : null,
    },
    {
      title: "Invoice No",
      dataIndex: "InvoiceNo",
      key: "InvoiceNo",
    },
    {
      title: "Dated",
      dataIndex: "Dated",
      key: "Dated",
      render: (_, record) =>
        record.ID != null ? moment(record.Dated).format("DD MMM YYYY") : "",
    },
    {
      title: "Description",
      dataIndex: "Description",
      key: "Description",
    },
    {
      title: "Cash",
      dataIndex: "Cash_Total",
      key: "Cash_Total",
      align: "right",
      render: (_, record) =>
        record.ID != null ? (
          NumberFormat(record.Cash_Total, 0)
        ) : (
          <strong>{NumberFormat(CashTotal, 0)}</strong>
        ),
    },
    {
      title: "Credit",
      dataIndex: "Credit_Total",
      key: "Credit_Total",
      align: "right",
      render: (_, record) =>
        record.ID != null ? (
          NumberFormat(record.Credit_Total, 0)
        ) : (
          <strong>{NumberFormat(CreditTotal, 0)}</strong>
        ),
    },
    {
      title: "Total",
      dataIndex: "TotalSales",
      key: "TotalSales",
      align: "right",
      render: (_, record) =>
        record.ID != null ? (
          NumberFormat(record.TotalSales, 0)
        ) : (
          <strong>{NumberFormat(record.TotalSales, 0)}</strong>
        ),
    },
    ...(canSeeProfit
      ? [
          {
            title: "Profit",
            dataIndex: "Profit",
            key: "Profit",
            align: "right",
            render: (_, record) =>
              record.ID != null ? (
                NumberFormat(record.Profit, 0)
              ) : (
                <strong>{NumberFormat(TotalProfit, 0)}</strong>
              ),
          },
        ]
      : []),
    {
      title: "Action",
      key: "action",
      render: (_, record) =>
        record.ID != null ? (
          <Space size="middle">
            <NavLink to={`/sales/edit-sales/${record.ID}`}>
              <Tooltip title="Edit Sale">
                <EditOutlined />
              </Tooltip>
            </NavLink>
            <Popconfirm
              title="Sure to delete?"
              discription="Are You sure to delete this data"
              onConfirm={(e) => handelDelete(record.ID)}
            >
              <Tooltip title="Delete Sale">
                <DeleteOutlined />
              </Tooltip>
            </Popconfirm>
            <NavLink to={`/sales/printnewsale/${record.ID}`} target="blank">
              <Tooltip title="Print Sale">
                <PrinterOutlined />
              </Tooltip>
            </NavLink>
          </Space>
        ) : (
          ""
        ),
    },
  ];

  const onPageChange = (page, pageSize) => {
    setPageNo(page);
  };

  const onPageSizeChange = (current, size) => {
    setPageNo(1); 
    setPageSize(size);
  };

  const handleStartDateChange = (date, dateString) => {
    if (!dateString) {
      SetStartDate("");
      setPageNo(1);
      return;
    }
    SetStartDate(dateString);
    setPageNo(1);
    if (EndDate && dayjs(dateString).isAfter(dayjs(EndDate), "day")) {
      SetEndDate(dateString);
    }
  };

  const handleEndDateChange = (date, dateString) => {
    if (!dateString) {
      SetEndDate("");
      setPageNo(1);
      return;
    }
    SetEndDate(dateString);
    setPageNo(1);
    if (StartDate && dayjs(dateString).isBefore(dayjs(StartDate), "day")) {
      SetStartDate(dateString);
    }
  };

  const disableStartDate = (current) => {
    if (!current) return false;
    if (EndDate && current.isAfter(dayjs(EndDate), "day")) return true;
    return false;
  };

  const disableEndDate = (current) => {
    if (!current) return false;
    if (StartDate && current.isBefore(dayjs(StartDate), "day")) return true;
    return false;
  };

  return (
    <>
      <LoginChecked />
      <div className="right-side-contents">
        <div className="page-content">
          <div className="page-header">
            <h3 className="page-title">Sales</h3>

            <div className="header-actions">
              <NavLink
                to={`/sales/print-sale-list/?StartDate=${printStartDate}&EndDate=${printEndDate}`}
                target="blank"
              >
                <Button type="dashed" size="large" shape="round">
                  <PrinterOutlined /> Print Report
                </Button>
              </NavLink>
              <NavLink to="/sales/add-sales">
                <Button type="primary" size="large" shape="round">
                  <PlusOutlined style={{ color: "white" }} /> Add Sale
                </Button>
              </NavLink>
            </div>
          </div>
          <div className="filters-wrap">
            <Form>
              <Form.Item name="StartDate">
                <DatePicker
                  placeholder="Start Date"
                  style={{ width: 150 }}
                  format="YYYY-MM-DD"
                  value={StartDate ? dayjs(StartDate) : null}
                  onChange={handleStartDateChange}
                  disabledDate={disableStartDate}
                  allowClear
                />
              </Form.Item>

              <Form.Item name="EndDate">
                <DatePicker
                  placeholder="End Date"
                  style={{ width: 150 }}
                  format="YYYY-MM-DD"
                  value={EndDate ? dayjs(EndDate) : null}
                  onChange={handleEndDateChange}
                  disabledDate={disableEndDate}
                  allowClear
                />
              </Form.Item>
            </Form>
          </div>

          <Table
            size="small"
            scroll={{
              x: "100%",
            }}
            loading={loading}
            columns={columns}
            dataSource={ListofSaleWithTotal}
            bordered
            pagination={false} // Remove table pagination
            //footer={getFooterContent}
          />
          <div className="text-end mt-5">
            <Pagination
              current={pageNo}
              pageSize={pageSize}
              size="small"
              total={totalRecords}
              onChange={onPageChange}
              onShowSizeChange={onPageSizeChange} // Handle page size change
              showSizeChanger
              showQuickJumper
              showTotal={(total) => `Total ${total} items`}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewSales;
